export const PHONE_DIAL_CODES = [
    { code: "AL", dialCode: "+355", name: "Albania" },
    { code: "AD", dialCode: "+376", name: "Andorra" },
    { code: "AR", dialCode: "+54", name: "Argentina" },
    { code: "AM", dialCode: "+374", name: "Armenia" },
    { code: "AU", dialCode: "+61", name: "Australia" },
    { code: "AT", dialCode: "+43", name: "Austria" },
    { code: "BY", dialCode: "+375", name: "Belarus" },
    { code: "BE", dialCode: "+32", name: "Belgium" },
    { code: "BA", dialCode: "+387", name: "Bosnia and Herzegovina" },
    { code: "BR", dialCode: "+55", name: "Brazil" },
    { code: "BG", dialCode: "+359", name: "Bulgaria" },
    { code: "CA", dialCode: "+1", name: "Canada" },
    { code: "CL", dialCode: "+56", name: "Chile" },
    { code: "HR", dialCode: "+385", name: "Croatia" },
    { code: "CY", dialCode: "+357", name: "Cyprus" },
    { code: "CZ", dialCode: "+420", name: "Czech Republic" },
    { code: "DK", dialCode: "+45", name: "Denmark" },
    { code: "EE", dialCode: "+372", name: "Estonia" },
    { code: "FI", dialCode: "+358", name: "Finland" },
    { code: "FR", dialCode: "+33", name: "France" },
    { code: "GE", dialCode: "+995", name: "Georgia" },
    { code: "DE", dialCode: "+49", name: "Germany" },
    { code: "GR", dialCode: "+30", name: "Greece" },
    { code: "HU", dialCode: "+36", name: "Hungary" },
    { code: "IS", dialCode: "+354", name: "Iceland" },
    { code: "IN", dialCode: "+91", name: "India" },
    { code: "IE", dialCode: "+353", name: "Ireland" },
    { code: "IL", dialCode: "+972", name: "Israel" },
    { code: "IT", dialCode: "+39", name: "Italy" },
    { code: "JP", dialCode: "+81", name: "Japan" },
    { code: "LV", dialCode: "+371", name: "Latvia" },
    { code: "LI", dialCode: "+423", name: "Liechtenstein" },
    { code: "LT", dialCode: "+370", name: "Lithuania" },
    { code: "LU", dialCode: "+352", name: "Luxembourg" },
    { code: "MT", dialCode: "+356", name: "Malta" },
    { code: "MX", dialCode: "+52", name: "Mexico" },
    { code: "MD", dialCode: "+373", name: "Moldova" },
    { code: "MC", dialCode: "+377", name: "Monaco" },
    { code: "ME", dialCode: "+382", name: "Montenegro" },
    { code: "NL", dialCode: "+31", name: "Netherlands" },
    { code: "MK", dialCode: "+389", name: "North Macedonia" },
    { code: "NO", dialCode: "+47", name: "Norway" },
    { code: "PL", dialCode: "+48", name: "Poland" },
    { code: "PT", dialCode: "+351", name: "Portugal" },
    { code: "RO", dialCode: "+40", name: "Romania" },
    { code: "SA", dialCode: "+966", name: "Saudi Arabia" },
    { code: "RS", dialCode: "+381", name: "Serbia" },
    { code: "SG", dialCode: "+65", name: "Singapore" },
    { code: "SK", dialCode: "+421", name: "Slovakia" },
    { code: "SI", dialCode: "+386", name: "Slovenia" },
    { code: "KR", dialCode: "+82", name: "South Korea" },
    { code: "ES", dialCode: "+34", name: "Spain" },
    { code: "SE", dialCode: "+46", name: "Sweden" },
    { code: "CH", dialCode: "+41", name: "Switzerland" },
    { code: "TR", dialCode: "+90", name: "Turkey" },
    { code: "UA", dialCode: "+380", name: "Ukraine" },
    { code: "AE", dialCode: "+971", name: "United Arab Emirates" },
    { code: "GB", dialCode: "+44", name: "United Kingdom" },
    { code: "US", dialCode: "+1", name: "United States" },
];

export function countryCodeToFlag(code) {
    if (typeof code !== "string" || code.length !== 2) return "";
    const base = 0x1f1e6 - 65;
    return (
        String.fromCodePoint(code.charCodeAt(0) + base) +
        String.fromCodePoint(code.charCodeAt(1) + base)
    );
}

export function parsePhoneDialCountry(phoneNumber, userCountry) {
    const fallback =
        userCountry && PHONE_DIAL_CODES.some((c) => c.code === userCountry)
            ? userCountry
            : "US";

    if (typeof phoneNumber !== "string" || !phoneNumber.startsWith("+")) {
        return fallback;
    }

    const matches = PHONE_DIAL_CODES.filter((c) =>
        phoneNumber.startsWith(c.dialCode),
    );
    if (!matches.length) return fallback;

    matches.sort((a, b) => b.dialCode.length - a.dialCode.length);
    const preferred = matches.find((c) => c.code === userCountry);
    return preferred ? preferred.code : matches[0].code;
}

export function getPhoneDialEntry(countryCode) {
    return PHONE_DIAL_CODES.find((c) => c.code === countryCode) || null;
}

export function splitPhoneNumber(phoneNumber, countryCode) {
    const entry = getPhoneDialEntry(countryCode);
    const dialCode = entry?.dialCode || "";
    const raw = typeof phoneNumber === "string" ? phoneNumber : "";
    const localNumber = raw.startsWith(dialCode)
        ? raw.slice(dialCode.length)
        : raw.replace(/^\+/, "");
    return { dialCode, localNumber };
}
